import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { pricingToggleContent } from '../i18n/content/pricingToggle';

const PricingToggle = ({ pricingMode, setPricingMode }) => {
  const { lang } = useLanguage();
  const c = pricingToggleContent[lang];
  return (
    <div className="flex justify-center mb-4">
      <div className="relative flex p-1.5 bg-surface-alt rounded-full border border-line w-full max-w-[440px] shadow-sm overflow-hidden">
        {/* Sliding Indicator */}
        <div
          className={`absolute inset-y-0 left-0 w-1/2 rounded-full transition-all duration-300 ease-out shadow-md ${
            pricingMode === 'multi' ? 'translate-x-full' : 'translate-x-0'
          }`}
          style={{ background: 'linear-gradient(160deg, #0a1a5f 0%, #002f9c 55%, #0d47ff 130%)' }}
        />

        {/* Buttons */}
        <button
          onClick={() => setPricingMode('standard')}
          className={`relative z-10 flex-1 min-w-0 py-3.5 px-2 sm:px-6 text-xs sm:text-sm font-bold rounded-full transition-colors duration-300 flex items-center justify-center gap-1.5 sm:gap-2 whitespace-nowrap ${
            pricingMode === 'standard' ? 'text-white' : 'text-ink-muted hover:text-ink'
          }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
            <line x1="8" y1="21" x2="16" y2="21"></line>
            <line x1="12" y1="17" x2="12" y2="21"></line>
          </svg>
          {c.screen}
        </button>

        <button
          onClick={() => setPricingMode('multi')}
          className={`relative z-10 flex-1 min-w-0 py-3.5 px-2 sm:px-6 text-xs sm:text-sm font-bold rounded-full transition-colors duration-300 flex items-center justify-center gap-1.5 sm:gap-2 whitespace-nowrap ${
            pricingMode === 'multi' ? 'text-white' : 'text-ink-muted hover:text-ink'
          }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="7" height="7"></rect>
            <rect x="14" y="3" width="7" height="7"></rect>
            <rect x="14" y="14" width="7" height="7"></rect>
            <rect x="3" y="14" width="7" height="7"></rect>
          </svg>
          {c.multi}
        </button>
      </div>
    </div>
  );
};

export default PricingToggle;
